import {createSlice} from '@reduxjs/toolkit'

const initialToastNotifications = {
  show: false,
  message: '',
  type: '',
}

const initialState = {
  countries: [],
  languages: [],
  languagesByCID: [],
  editMode: false,
  localCurrency: 'MXN',
  country: {id: 0, code: '', name: ''},
  canCancelPage: false,
  shellActive: false,
  shellPath: '',
  toastNotifications: initialToastNotifications,
}

const common = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setToastNotifications: (state, action) => {
      return {
        ...state,
        toastNotifications: action.payload,
      }
    },
    resetToastNotifications: state => {
      return {
        ...state,
        toastNotifications: initialToastNotifications,
      }
    },
    setCountries: (state, action) => {
      return {
        ...state,
        countries: action.payload,
      }
    },
    setLanguages: (state, action) => {
      return {
        ...state,
        languages: action.payload,
      }
    },
    setLanguagesByCID: (state, action) => {
      return {
        ...state,
        languagesByCID: action.payload,
      }
    },
    setEditMode: (state, action) => {
      return {
        ...state,
        editMode: action.payload,
      }
    },
    setCountry: (state, action) => {
      return {
        ...state,
        country: action.payload,
      }
    },
    setCancelPage: state => {
      return {
        ...state,
        canCancelPage: true,
      }
    },
    setStayPage: state => {
      return {
        ...state,
        canCancelPage: false,
      }
    },
    setShellActive: (state, action) => {
      return {
        ...state,
        shellActive: action.payload,
      }
    },
    setShellPath: (state, action) => {
      return {
        ...state,
        shellPath: action.payload,
      }
    },
    resetCommon: () => initialState,
  },
})

export const {
  setCountries,
  setLanguages,
  resetCommon,
  setLanguagesByCID,
  setEditMode,
  setCountry,
  setCancelPage,
  setStayPage,
  setShellActive,
  setShellPath,
  setToastNotifications,
  resetToastNotifications,
} = common.actions

export const selectShellActive = state => state.common.shellActive
export const selectShellPath = state => state.common.shellPath
export const commonSliceReducer = common.reducer
